export default import.meta.ROLLDOWN_FILE_URL_aLISaAY6NSiJFT$6GdtrfA_096b2a3cb944eea4f93e1561